import { useNavigation, useRoute } from '@react-navigation/native';
import { PERFORMANCE_MAIN_SCREEN } from '@v2/pages/performance/navigation';

export const useManagePerformanceHeader = () => {
  const navigation = useNavigation<any>();
  const route = useRoute();

  const activeScreenNameWithoutMachineMainScreen = route?.name?.replace(PERFORMANCE_MAIN_SCREEN, '') || '';

  const handleNavigate = (performanceScreen: string) => {
    navigation.replace(`${PERFORMANCE_MAIN_SCREEN}${performanceScreen}`, route?.params);
  };

  const checkIsSelected = (title: string) => title === activeScreenNameWithoutMachineMainScreen;

  return {
    handleNavigate,
    activeScreenNameWithoutMachineMainScreen,
    checkIsSelected,
  };
};
